import useIsMobile from "@/hooks/useIsMobile";
import { useRef, useState, useEffect } from "react";

const TopPerformerCard = ({
  title = null,
  mostRunData = null,
  mostWicketsData = null,
}) => {
  const scrollRef = useRef(null);
  const [activeIndex, setActiveIndex] = useState(0);
  const isMobile = useIsMobile();
  useEffect(() => {
    const handleScroll = () => {
      if (!scrollRef.current) return;
      const scrollLeft = scrollRef.current.scrollLeft;
      const scrollWidth = scrollRef.current.scrollWidth;
      const clientWidth = scrollRef.current.clientWidth;

      // Calculate active dot index
      const index = Math.round((scrollLeft / (scrollWidth - clientWidth)) * 1);
      setActiveIndex(index);
    };

    const scrollEl = scrollRef.current;
    scrollEl?.addEventListener("scroll", handleScroll);

    return () => scrollEl?.removeEventListener("scroll", handleScroll);
  }, []);
  useEffect(() => {
    if (!isMobile || !scrollRef.current) return;

    const interval = setInterval(() => {
      const container = scrollRef.current;
      const width = container.clientWidth;
      const nextIndex = (activeIndex + 1) % 2;

      container.scrollTo({
        left: nextIndex * width,
        behavior: "smooth",
      });

      setActiveIndex(nextIndex);
    }, 10000); // 2 seconds

    return () => clearInterval(interval);
  }, [activeIndex, isMobile]);

  // top wickects  https://sports-feeds.intoday.in/live-score/api_v1/newstak/series_player_stats/8307_13_json/
  // top runs https://sports-feeds.intoday.in/live-score/api_v1/newstak/series_player_stats/8307_2_json/

  return (
    <div className="w-full ">
      <h2 className="font-semibold mb-2 text-lg">{title}</h2>

      <div className="relative w-full mx-auto p-4 rounded-lg shadow-lg text-white overflow-hidden">
        <div
          className="absolute inset-0 bg-cover bg-bottom bg-no-repeat"
          style={{
            backgroundImage: "url('https://akm-img-a-in.tosshub.com/lingo/newstak/resources/prod/bg_tp.png')",
            backgroundPosition: "center 80%",
            filter: "blur(1.2px)",
          }}
        ></div>
        {/* <div  className={`absolute inset-0 bg-gradient-to-r to-[rgba(237,77,41,1.6)] via-transparent from-[rgba(104,40,121,1.7)] opacity-150 ${isMobile ? `bg-[rgba(104,40,121,1.7)]` : `bg-[rgba(237,77,41,1.6)]`}  `}></div> */}
        <div
          className={`absolute inset-0 z-0
    ${isMobile
              ? activeIndex === 0
                ? "bg-gradient-to-r from-[rgba(104,40,121,0.8)] to-[rgba(104,40,121,0.8)]"
                : "bg-gradient-to-r from-[rgba(237,77,41,0.8)] to-[rgba(237,77,41,0.8)]"
              : "bg-gradient-to-r from-[rgba(104,40,121,0.8)] to-[rgba(237,77,41,0.8)]"
            }
  `}
        ></div>

        <div
          ref={scrollRef}
          style={{ scrollbarWidth: "none" }}
          className="relative z-10 flex md:flex-row items-center justify-between overflow-x-auto snap-x snap-mandatory w-full  scrollbar-hide scroll-smooth"
        >
          <div className="w-full md:w-[45%] flex-shrink-0 snap-center">
            <div className="flex">
              <div className="flex-1 flex flex-col items-start text-left">
                <h2 className="text-lg font-light">
                  {mostWicketsData?.leaderboard[0]?.player_name?.split(" ")[0]}
                </h2>
                <h2 className="text-2xl font-bold flex items-center gap-2">
                  {mostWicketsData?.leaderboard[0]?.player_name
                    ?.split(" ")
                    ?.slice(1)
                    .join(" ")}
                  <span className="w-6 h-6">
                    <img
                      src="https://akm-img-a-in.tosshub.com/lingo/newstak/resources/prod/purple_cap.png"
                      alt="Purple Cap"
                      className="w-full h-full"
                    />
                  </span>
                </h2>
                <p className="flex items-center gap-2 my-4  text-sm">
                  <img
                    src={` https://akm-img-a-in.tosshub.com/lingo/nwtak/resources/${mostWicketsData?.leaderboard[0]?.team_short_name?.toLowerCase()}1.png`}
                    alt={mostWicketsData?.leaderboard[0]?.team_short_name}
                    className="w-5 h-5  "
                  />
                  {mostWicketsData?.leaderboard[0]?.team_short_name} • Purple
                  Cap
                </p>
              </div>

              <img
                // src="https://akm-img-a-in.tosshub.com/lingo/newstak/resources/prod/harshalpatel.png"
                src={`https://akm-img-a-in.tosshub.com/sites/sports/ipl/resources_live/images/players_img/ipl_2025/${mostWicketsData?.leaderboard[0]?.player_id}.png`}
                alt={mostWicketsData?.leaderboard[0]?.player_name}
                className="h-28"
                onError={(e) => {
                  e.target.src =
                    "https://akm-img-a-in.tosshub.com/sites/sports/ipl/resources_live/images/players_img/ipl_2025/0.png";
                }}
              />
            </div>

            <div className="mt-4 grid grid-cols-3 gap-2 text-center w-full">
              <div className="bg-white bg-opacity-20 p-3 rounded-md">
                <h3 className="text-xl font-bold">
                  {mostWicketsData?.leaderboard[0]?.wickets}
                </h3>
                <p className="text-sm">Wickets</p>
              </div>
              <div className="bg-white bg-opacity-20 p-3 rounded-md">
                <h3 className="text-xl font-bold">
                  {mostWicketsData?.leaderboard[0]?.matches_played}
                </h3>
                <p className="text-sm">Matches</p>
              </div>
              <div className="bg-white bg-opacity-20 p-3 rounded-md">
                <h3 className="text-xl font-bold">
                  {mostWicketsData?.leaderboard[0]?.economy}
                </h3>
                <p className="text-xs">Economy Rate</p>
              </div>
            </div>
          </div>

          <div className="hidden md:block w-[2px] h-[240px] bg-white bg-opacity-30"></div>

          <div className="w-full md:w-[45%] flex-shrink-0 snap-center">
            <div className="flex">
              <div className="flex-1 flex flex-col items-start text-left">
                <h2 className="text-lg font-light">
                  {mostRunData?.leaderboard[0]?.player_name?.split(" ")[0]}
                </h2>

                <h2 className="text-2xl font-bold flex items-center gap-2">
                  {mostRunData?.leaderboard[0]?.player_name?.split(" ")[1]}
                  <span className="w-6 h-6">
                    <img
                      src="https://akm-img-a-in.tosshub.com/lingo/newstak/resources/prod/orange_cap.png"
                      alt="Orange Cap"
                      className="w-full h-full"
                    />
                  </span>
                </h2>
                <p className="flex items-center gap-2 my-4 text-sm">
                  <img
                    src={` https://akm-img-a-in.tosshub.com/lingo/nwtak/resources/${mostRunData?.leaderboard[0]?.team_short_name?.toLowerCase()}1.png`}
                    alt={mostRunData?.leaderboard[0]?.team_short_name}
                    className="w-5 h-5 "
                  />
                  {mostRunData?.leaderboard[0]?.team_short_name} • Orange Cap
                </p>
              </div>

              <img
                // src="https://akm-img-a-in.tosshub.com/lingo/newstak/resources/prod/kohli.png"
                src={`https://akm-img-a-in.tosshub.com/sites/sports/ipl/resources_live/images/players_img/ipl_2025/${mostRunData?.leaderboard[0]?.player_id}.png`}
                alt={mostRunData?.leaderboard[0]?.player_name}
                className="h-28"
                onError={(e) => {
                  e.target.src =
                    "https://akm-img-a-in.tosshub.com/sites/sports/ipl/resources_live/images/players_img/ipl_2025/0.png";
                }}
              />
            </div>

            <div className="mt-4 grid grid-cols-3 gap-2 text-center w-full">
              <div className="bg-white bg-opacity-20 p-3 rounded-md">
                <h3 className="text-xl font-bold">
                  {mostRunData?.leaderboard[0]?.runs_scored}
                </h3>
                <p className="text-sm">Runs</p>
              </div>
              <div className="bg-white bg-opacity-20 p-3 rounded-md">
                <h3 className="text-xl font-bold">
                  {mostRunData?.leaderboard[0]?.matches_played}{" "}
                </h3>
                <p className="text-sm">Matches</p>
              </div>
              <div className="bg-white bg-opacity-20 p-3 rounded-md">
                <h3 className="text-xl font-bold">
                  {mostRunData?.leaderboard[0]?.highest_score}
                </h3>
                <p className="text-sm">Hs. Score</p>
              </div>
            </div>
          </div>
        </div>

        <div className="flex justify-center mt-2 gap-2 md:hidden">
          {[0, 1].map((index) => (
            <span
              key={index}
              className={`w-2.5 h-2.5 rounded-full transition-all ${activeIndex === index
                ? "bg-white scale-125 w-5"
                : "bg-white opacity-50"
                }`}
            ></span>
          ))}
        </div>
      </div>
    </div>
  );
};

export default TopPerformerCard;
